import { render, staticRenderFns } from "./ProductStockList.vue?vue&type=template&id=26f18c5a&scoped=true&"
import script from "./ProductStockList.vue?vue&type=script&lang=js&"
export * from "./ProductStockList.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockList.vue?vue&type=style&index=0&id=26f18c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f18c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f18c5a')) {
      api.createRecord('26f18c5a', component.options)
    } else {
      api.reload('26f18c5a', component.options)
    }
    module.hot.accept("./ProductStockList.vue?vue&type=template&id=26f18c5a&scoped=true&", function () {
      api.rerender('26f18c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/report/ProductStockList.vue"
export default component.exports